export default __webpack_public_path__ + "static/media/feeling_1_mobile_view.b3d384cb.svg";